import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { LoginState, useSelectLoginState } from '@treneo/features/auth';
import { CURRENT_USER_QUERY_KEY } from '@treneo/features/user';

export const useAuthInitializer = () => {
  const queryClient = useQueryClient();
  const loginState = useSelectLoginState();

  useEffect(() => {
    if (loginState === LoginState.NOT_LOGGED) {
      queryClient.removeQueries({ queryKey: CURRENT_USER_QUERY_KEY });
    }
  }, [loginState, queryClient]);
};
